import { render, staticRenderFns } from "./manageRoles.vue?vue&type=template&id=515b1046&scoped=true"
import script from "./manageRoles.vue?vue&type=script&lang=js"
export * from "./manageRoles.vue?vue&type=script&lang=js"
import style0 from "./manageRoles.vue?vue&type=style&index=0&id=515b1046&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "515b1046",
  null
  
)

export default component.exports